import { type SubtypeSectionProps, subtypeControls } from "./support";
import { fieldGrid } from "../../components/styles";

export const serviceFieldLabels = {
  serviceAreaText: "Service area",
  leadTimeHours: "Lead time (hours)",
  availabilityNotes: "Availability notes",
} as const;

export function ServiceSection(props: SubtypeSectionProps) {
  const c = subtypeControls(props);
  return (
    <div className={fieldGrid}>
      {c.text("serviceAreaText", serviceFieldLabels.serviceAreaText, { maxLength: 300 })}
      {c.whole("leadTimeHours", serviceFieldLabels.leadTimeHours, {
        hint: "How far ahead a request must be made.",
      })}
      {c.area("availabilityNotes", serviceFieldLabels.availabilityNotes, {
        rows: 3,
        maxLength: 1000,
      })}
    </div>
  );
}
